import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-end",
  tabindex: "-1",
  id: "companiesSettings"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "offcanvas-title" }, "Settings"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close shadow-none",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Close"
  })
], -1)
const _hoisted_3 = { class: "offcanvas-body" }
const _hoisted_4 = {
  ref: "sortableList",
  class: "list-group"
}
const _hoisted_5 = ["data-key"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = ["id", "value", "onUpdate:modelValue", "onChange"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrows-vertical me-2" }, null, -1)
const _hoisted_9 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortableItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.key,
            class: "list-group-item text-secondary sortable-item",
            "data-key": item.key
          }, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: item.key,
                value: item.key,
                "onUpdate:modelValue": ($event: any) => ((item.enabled) = $event),
                class: "form-check-input me-2",
                onChange: ($event: any) => (_ctx.handleItemChange(item))
              }, null, 40, _hoisted_7), [
                [_vModelCheckbox, item.enabled]
              ]),
              _hoisted_8,
              _createElementVNode("label", {
                for: item.key,
                class: "form-check-label"
              }, [
                _createElementVNode("strong", null, _toDisplayString(item.header), 1)
              ], 8, _hoisted_9)
            ])
          ], 8, _hoisted_5))
        }), 128))
      ], 512),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetDefault && _ctx.resetDefault(...args))),
        class: "btn btn-secondary btn-sm mt-25"
      }, "Reset to Defaults")
    ])
  ]))
}